export const PROJECT_CONSTS = {
    GET_PROJECTS: "GET_PROJECTS",
    CREATE_PROJECT: "CREATE_PROJECT",
    UPDATE_PROJECTS_POSITIONS: "UPDATE_PROJECTS_POSITIONS",
    UPDATE_PROJECT_BY_ID: "UPDATE_PROJECT_BY_ID",
    DELETE_PROJECT_BY_ID: "DELETE_PROJECT_BY_ID",
};
